<div class="textarea__container">
  <div class="{{className || 'textarea__heading'}}">
    {{label}}@if (starIcon) {
    <span class="spmred">{{starIcon}}</span>
  }
</div>
<textarea
  class="textarea__inputfield"
  [formControl]="control"
  name="package-description"
  rows="5"
  placeholder={{placeholder}}>
</textarea>
</div>